'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { SvgAiSpark } from '@/app/_components/AiAgentBanner';
import styles from './ChatGeneratingIndicator.module.scss';
export const AI_SPARK_LAYOUT_ID = 'wello-agent-ai-spark';
const ICON_MOVE_DURATION_S = 0.9;
interface ChatGeneratingIndicatorProps {
  isGenerating: boolean;
  label?: string;
}
export const ChatGeneratingIndicator = t0 => {
  const $ = _c(27);
  const {
    isGenerating,
    label
  } = t0;
  const [isMoving, setIsMoving] = useState(false);
  let t1;
  let t2;
  if ($[0] !== isMoving) {
    t1 = () => {
      if (!isMoving) {
        return;
      }
      const id = window.setTimeout(() => setIsMoving(false), ICON_MOVE_DURATION_S * 1000);
      return () => window.clearTimeout(id);
    };
    t2 = [isMoving];
    $[0] = isMoving;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const t3 = !isGenerating;
  const t4 = isGenerating ? "\uC6F0\uB85C AI\uAC00 \uB2F5\uBCC0\uC744 \uC791\uC131 \uC911\uC785\uB2C8\uB2E4" : undefined;
  const t5 = isGenerating ? "status" : undefined;
  let t6;
  if ($[3] !== isGenerating || $[4] !== isMoving) {
    t6 = isMoving ? {
      opacity: [1, 0.25, 1]
    } : isGenerating ? {
      opacity: [0.78, 1, 0.78]
    } : {
      opacity: 1
    };
    $[3] = isGenerating;
    $[4] = isMoving;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== isGenerating || $[7] !== isMoving) {
    t7 = isMoving ? {
      duration: ICON_MOVE_DURATION_S,
      times: [0, 0.5, 1],
      ease: "easeInOut"
    } : isGenerating ? {
      duration: 1.25,
      ease: "easeInOut",
      repeat: Infinity
    } : {
      duration: 0.2,
      ease: "easeOut"
    };
    $[6] = isGenerating;
    $[7] = isMoving;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      duration: ICON_MOVE_DURATION_S,
      ease: [0.22, 1, 0.36, 1]
    };
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t7) {
    t9 = {
      opacity: t7,
      layout: t8
    };
    $[10] = t7;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setIsMoving(true);
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== isGenerating) {
    t11 = <SvgAiSpark className="size-24" isAnimated={isGenerating} />;
    $[13] = isGenerating;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t11 || $[16] !== t6 || $[17] !== t9) {
    t12 = <motion.div animate={t6} className="flex size-28 items-center justify-center rounded-pill" layoutId={AI_SPARK_LAYOUT_ID} transition={t9} onLayoutAnimationStart={t10}>{t11}</motion.div>;
    $[15] = t11;
    $[16] = t6;
    $[17] = t9;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== label) {
    t13 = label && <span className={cn("ml-8 text-Gray-550 typo-body4", styles.shimmerLabel)}>{label}</span>;
    $[19] = label;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t12 || $[22] !== t13 || $[23] !== t3 || $[24] !== t4 || $[25] !== t5) {
    t14 = <div aria-hidden={t3} aria-label={t4} className="flex h-44 w-full items-center justify-start pl-2" role={t5}>{t12}{t13}</div>;
    $[21] = t12;
    $[22] = t13;
    $[23] = t3;
    $[24] = t4;
    $[25] = t5;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  return t14;
};